/**
 * Pagination - Pagination controls for the labs table
 */
import React from 'react'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import styles from '../LabsV2.module.css'

const Pagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  pageSize,
  pageSizeOptions,
  onPageSizeChange
}) => {
  const isShowAll = pageSize === 'all'
  const startItem = isShowAll ? 1 : (currentPage - 1) * itemsPerPage + 1
  const endItem = isShowAll ? totalItems : Math.min(currentPage * itemsPerPage, totalItems)

  const handlePageSizeChange = (e) => {
    const value = e.target.value
    onPageSizeChange(value === 'all' ? 'all' : parseInt(value))
  }

  return (
    <div className={styles.paginationWrapper}>
      <div className={styles.paginationInfo}>
        Showing {startItem}-{endItem} of {totalItems} labs
      </div>

      <div className={styles.paginationControls}>
        {/* Page size dropdown */}
        <div className={styles.pageSizeSelector}>
          <label htmlFor="pageSize" className={styles.pageSizeLabel}>Show:</label>
          <select
            id="pageSize"
            className={styles.pageSizeDropdown}
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            {pageSizeOptions.map((option) => (
              <option key={option} value={option}>
                {option === 'all' ? 'All' : option}
              </option>
            ))}
          </select>
        </div>

        {/* Prev/Next buttons - hidden when showing all */}
        {!isShowAll && (
          <>
            <button
              className={styles.paginationButton}
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <AiOutlineLeft size={16} />
              Previous
            </button>

            <button
              className={styles.paginationButton}
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
              <AiOutlineRight size={16} />
            </button>
          </>
        )}
      </div>
    </div>
  )
}

export default Pagination
